import { useMemo } from 'react'
import { sizeConfig } from './config'
import type { ISize} from './config'

interface IProps {
  color?: string
  size?: ISize
  round?: boolean // 是否圆角
  plain?: boolean // 是否是朴素标签
  bordered?: boolean // 是否有边框
  children?: React.ReactNode // 文字内容
  [key: string]: any
}

function Tag(props: IProps) {
  const { color = '#FF9F06', size = 'middle', round = false, plain, bordered = true, children, ...attrs } = props

  const styles = useMemo(() => {
    const styleConfig = sizeConfig[size]
    const { height } = styleConfig
    const colorStyle = plain ?
      {
        color,
        backgroundColor: '#ffffff',
        borderColor: color,
      } :
      {
        color: '#ffffff',
        backgroundColor: color,
        borderColor: color,
      }

    const stylesdata: any = {
      ...styleConfig,
      textAlign: 'center',
      display: 'inline-block',
      boxSizing: 'border-box',
      ...colorStyle,
    }
    if (!bordered) stylesdata.border = 'none'
    if (round) stylesdata.borderRadius = (Number(height.replace('px', '')) / 2 + 'px')
    return stylesdata
  }, [color, size, plain, round, bordered])

  return (
    <div { ...attrs } style={ styles }>{ children }</div>
  )
}

export default Tag
